import dayjs from 'dayjs'
import axios from '../../axios'
export default {
  namespaced: true,
  state: {
    vehicles: [],
  },
  mutations: {
    SET_VEHICLES(state, vehicles) {
      state.vehicles = vehicles
    },
    REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.vehicles.findIndex((p) => p.id === itemId)
      state.vehicles.splice(ItemIndex, 1)
    },
  },
  actions: {
    addItem(_, item) {
      return new Promise((resolve, reject) => {
        axios
          .post("eld/vehicles/", item)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log(this.response), reject(error);
          });
      });
    },
    fetchDataListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("eld/vehicles/")
          .then((response) => {
            commit("SET_VEHICLES", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    updateItem(_, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`eld/vehicles/${item.id}/`, item)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    removeItem({ commit }, itemId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`eld/vehicles/${itemId}/`)
          .then((response) => {
            commit("REMOVE_ITEM", itemId);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },




  },
}